export class UnauthorizedMsg {
    constructor() {
        this.naming = "UnauthorizedMsg";
    }
}
